import { render, staticRenderFns } from "./HeroSectionDesktop.vue?vue&type=template&id=54d9759d&scoped=true&"
import script from "./HeroSectionDesktop.vue?vue&type=script&lang=ts&setup=true&"
export * from "./HeroSectionDesktop.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./HeroSectionDesktop.vue?vue&type=style&index=0&id=54d9759d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d9759d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d9759d')) {
      api.createRecord('54d9759d', component.options)
    } else {
      api.reload('54d9759d', component.options)
    }
    module.hot.accept("./HeroSectionDesktop.vue?vue&type=template&id=54d9759d&scoped=true&", function () {
      api.rerender('54d9759d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/HeroSectionDesktop.vue"
export default component.exports